module.exports = __webpack_public_path__ + "static/media/letter.4b71ad39.svg";